/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SandalsInputs */

const en_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandals`)
};

const es_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandalias`)
};

const fr_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandales`)
};

const de_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandalen`)
};

const ja_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンダル`)
};

const zh_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`凉鞋`)
};

const ar_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صنادل`)
};

const id_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandal`)
};

const it_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandali`)
};

const ru_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сандалии`)
};

const pt_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandálias`)
};

const ko_val_sandals = /** @type {(inputs: Val_SandalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`샌들`)
};

/**
* | output |
* | --- |
* | "Sandals" |
*
* @param {Val_SandalsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_sandals = /** @type {((inputs?: Val_SandalsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SandalsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_sandals(inputs)
	if (locale === "es") return es_val_sandals(inputs)
	if (locale === "fr") return fr_val_sandals(inputs)
	if (locale === "de") return de_val_sandals(inputs)
	if (locale === "ja") return ja_val_sandals(inputs)
	if (locale === "zh") return zh_val_sandals(inputs)
	if (locale === "ar") return ar_val_sandals(inputs)
	if (locale === "id") return id_val_sandals(inputs)
	if (locale === "it") return it_val_sandals(inputs)
	if (locale === "ru") return ru_val_sandals(inputs)
	if (locale === "pt") return pt_val_sandals(inputs)
	return ko_val_sandals(inputs)
});